import { Crop } from '@next/arable-lib/crop';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { CropState } from 'src/app/shared/models';

import { CropFieldActions, CropFieldActionTypes } from '../actions/crop-field.actions';

export const adapter: EntityAdapter<Crop> = createEntityAdapter<Crop>();
export const initialState: CropState = adapter.getInitialState({});

export const mostUsedCropReducer = (state = initialState, action: CropFieldActions): CropState => {
  switch (action.type) {
    case CropFieldActionTypes.LoadMostUsedCropsSuccess: {
      return adapter.setAll(action.crops, state);
    }

    default: {
      return state;
    }
  }
};
